import { useState } from 'react'

const ERROR_LOOKUP: { code: string; keywords: string[]; solution: string }[] = [
  { code: 'SYSTEM_RUN_DENIED', keywords: ['系统运行拒绝', 'run denied'], solution: '沙盒或 elevated 权限拒绝执行。检查 sandbox.mode 与 tools.elevated 配置，或在确认安全的前提下对可信操作放行。' },
  { code: '429', keywords: ['429', 'rate limit', '配额'], solution: 'API 限流或配额耗尽。切换模型、稍后重试或使用本地模型（Ollama）。' },
  { code: 'API Key', keywords: ['api key', 'invalid key', '密钥'], solution: '检查 .env 或 openclaw.json 中的 API Key 是否正确、未过期、有足够额度。' },
  { code: 'EADDRINUSE', keywords: ['EADDRINUSE', '端口占用'], solution: '18789 或其他端口被占用。更换端口或关闭占用进程。' },
  { code: 'Chromium', keywords: ['chromium', 'browser', '崩溃'], solution: 'Docker 需配置 shm_size: \'2gb\'；本地确保 Chromium/Playwright 依赖完整安装。' },
]

function filterErrors(query: string) {
  const q = query.trim().toLowerCase()
  if (!q) return ERROR_LOOKUP
  return ERROR_LOOKUP.filter(
    (e) =>
      e.code.toLowerCase().includes(q) ||
      e.keywords.some((k) => k.toLowerCase().includes(q))
  )
}

export function SecFix() {
  const [errorQuery, setErrorQuery] = useState('')
  const filtered = filterErrors(errorQuery)

  return (
    <div className="page">
      <h1 className="section-title">安全与排障</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        沙盒配置、openclaw doctor 修复、常见报错与安全红线。支持中英文报错精确匹配。
      </p>

      <div className="card">
        <h2>常见报错速查</h2>
        <p>输入英文错误码（如 SYSTEM_RUN_DENIED）或中文关键词，精确匹配解决方案。</p>
        <input
          type="search"
          className="search-input"
          placeholder="输入错误码或关键词…"
          value={errorQuery}
          onChange={(e) => setErrorQuery(e.target.value)}
          aria-label="搜索报错"
        />
        <ul className="error-list">
          {filtered.map((e) => (
            <li key={e.code}>
              <code>{e.code}</code>
              <p>{e.solution}</p>
            </li>
          ))}
        </ul>
        {filtered.length === 0 && errorQuery && <p className="muted">未找到匹配报错，可查看下方排障诊所或官方文档。</p>}
      </div>

      <div className="card">
        <h2>2 分钟排障诊所</h2>
        <h3>API Key 耗尽或 Anthropic 长上下文 429</h3>
        <p>检查用量与配额；可切换模型或使用本地模型（Ollama）缓解。</p>
        <h3>通道掉线（WhatsApp 扫码失败、心跳断开）</h3>
        <p>建议使用 <code>caffeinate</code>（Mac）保持唤醒；检查网络与 token 是否过期。</p>
        <h3>排障神器</h3>
        <p><code>openclaw doctor --fix</code> 自动修复配置；<code>openclaw logs --follow</code> 实时查看日志抓虫。</p>
      </div>

      <div className="card">
        <h2>安装基建</h2>
        <p>Windows 用户请参考 WSL2 详细配置指引；Docker Compose 需配置 <code>shm_size: '2gb'</code> 与开放 18789 端口（见部署专区）。</p>
      </div>

      <div className="card">
        <h2>安全红线守则</h2>
        <ul>
          <li><strong>不要</strong>把 API 或 OpenClaw 暴露在公网；配合 Tailscale 或将 <code>gateway.bind</code> 设为 <code>loopback</code>。</li>
          <li>ClawHub 存在恶意 Skill，安装前用 ClawDex 或审计 <code>SKILL.md</code>。</li>
          <li>开发/运维场景建议在 Docker 中开启 <code>sandbox.mode: "all"</code>（完全沙盒），并配置 <code>tools.elevated</code> 进行权限审批，防止 AI 误删系统文件。</li>
        </ul>
      </div>
    </div>
  )
}
